/**
 * Trust Profile Test Page
 * Epic 7: UI Testing Page for Trust, Reputation & Marketplace Governance
 */

import React from 'react';
import TrustProfileTest from '../features/intelligence/components/TrustProfileTest';

const TrustProfileTestPage = () => {
  return <TrustProfileTest />;
};

export default TrustProfileTestPage;
